import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import Banner from "../assets/images/banner/page_banner.jpg";

const Contact: React.FC = () => {
  return (
    <div className="bg-white min-h-screen">

      {/* HERO */}
      <section className="relative h-[420px] flex items-center justify-center text-white">

        {/* background */}
        <div className="absolute inset-0">
          <img
            src={Banner}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-primary/80"></div>
        </div>

        <div className="relative text-center mt-20">
          <h1 className="text-5xl font-black">Contact Us</h1>
          <p className="mt-3 text-lg opacity-90">
            BBMH Hospital Bhilwara
          </p>
        </div>
      </section>
      
      {/* CONTACT SECTION */}
      <section className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-2 gap-12">

        {/* LEFT INFO */}
        <div>
          <h2 className="text-3xl font-bold mb-6">Get In Touch</h2>
          <p className="text-gray-600 mb-8">
            For appointment, consultation and emergency urology treatment,
            contact BBMH Hospital Bhilwara. Our team is ready to help you.
          </p>

          <div className="space-y-6">

            <div className="flex items-center gap-4">
              <Phone className="text-primary" />
              <div>
                <p className="font-semibold">Call Us</p>
                <a href="tel: +917774956489"><p className="text-gray-600">+91 77749 56489</p></a>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <Mail className="text-primary" />
              <div>
                <p className="font-semibold">Email</p>
                <a href="mailto: drsachiturologist@gmail.com"><p className="text-gray-600">drsachiturologist@gmail.com</p></a>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <MapPin className="text-primary" />
              <div>
                <p className="font-semibold">Address</p>
                <p className="text-gray-600">
                  BBMH Hospital, RC Vyas Colony, Bhilwara, Rajasthan
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <Clock className="text-primary" />
              <div>
                <p className="font-semibold">Timing</p>
                <p className="text-gray-600">
                  Mon - Sat : 9:00 AM - 7:00 PM
                </p>
              </div>
            </div>

          </div>
        </div>

        {/* FORM */}
        <div className="bg-gray-50 p-8 rounded-2xl shadow-xl">
          <h3 className="text-2xl font-bold mb-2">
            Send Us a Message
          </h3>
          <p className="text-gray-500 mb-8">
            Have questions? Our team will respond shortly.
          </p>

          <form className="space-y-4">
            <div className="grid md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="Full Name"
                className="w-full border p-3 rounded-lg"
              />

              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full border p-3 rounded-lg"
              />

              <input
                type="email"
                placeholder="Email Address"
                className="w-full border p-3 rounded-lg"
              />

              <input
                type="text"
                placeholder="Address"
                className="w-full border p-3 rounded-lg"
              />
            </div>
            <textarea
              placeholder="Message"
              rows={4}
              className="w-full border p-3 rounded-lg"
            ></textarea>

            <button className="bg-primary text-white w-full py-3 rounded-lg font-semibold text-lg">
              Contact Us
            </button>

          </form>
        </div>

      </section>

      {/* MAP */}
      <section className="px-6 pb-20">
        <div className="max-w-7xl mx-auto rounded-2xl overflow-hidden shadow-lg">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.2103132436255!2d74.64336017444735!3d25.35727322520017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3968c39b6194c2c1%3A0x36953cfd1840cfb0!2sBrijesh%20Banger%20Memorial%20Hospital!5e1!3m2!1sen!2sin!4v1734433385779!5m2!1sen!2sin"
            width="100%"
            height="350"
            loading="lazy"
          ></iframe>
        </div>
      </section>

    </div>
  );
};

export default Contact;
